<div class="recurring-item-configuration">
  <h1 mat-dialog-title>
    {{ (injectData.mode === 'show' ? 'button.showRecurrence' : 'button.manageRecurrence') | translate }}
  </h1>
  <form #form="ngForm" [formGroup]="formGroup" (ngSubmit)="submitCron()">
    <div mat-dialog-content [class]="{ disabled: injectData.mode === 'show' }">
      <cron-editor formControlName="cron" [options]="cronOptions"></cron-editor>
      <div>
        <mat-label>{{ 'field.ends' | translate }}</mat-label>
        <mat-radio-group formControlName="selectedLimitType">
          <mat-radio-button [value]="ERecursionLimitType.never">{{ 'field.never' | translate }}</mat-radio-button>
          <div class="d-flex radio-row">
            <mat-radio-button class="ends-radio-button" [value]="ERecursionLimitType.endDateLimit">{{
              'field.onTheDate' | translate
            }}</mat-radio-button>
            <app-date-range-picker
              [formControl]="formGroup.controls.endDateLimit"
              [configurationInput]="datePickerConfiguration"
              [isFormSubmitted]="form.submitted"
            >
            </app-date-range-picker>
          </div>
          <div class="d-flex radio-row">
            <mat-radio-button class="ends-radio-button" [value]="ERecursionLimitType.numberLimit">{{
              'field.afterNumberOfOccurrences' | translate
            }}</mat-radio-button>
            <div>
              <mat-form-field appearance="outline" class="occurrences-input">
                <mat-label>{{ 'field.occurrences' | translate }}</mat-label>
                <input matInput [formControl]="formGroup.controls.numberLimit" type="number" />
              </mat-form-field>
              <app-custom-mat-error
                [control]="formGroup.controls.numberLimit"
                [isFormSubmitted]="form.submitted"
              ></app-custom-mat-error>
            </div>
          </div>
        </mat-radio-group>
      </div>
    </div>

    <mat-dialog-actions align="end">
      @if (injectData.mode === 'manage') {
        <button mat-button mat-dialog-close>{{ 'button.cancel' | translate }}</button>
        <button mat-stroked-button type="button" (click)="clearCron()">{{ 'button.clear' | translate }}</button>
      }
      <button mat-flat-button type="submit">
        {{ 'button.ok' | translate }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
